export default __webpack_public_path__ + "static/media/footer-twitter.b261e551.svg";